import { useHistory } from 'react-router-dom';
import { ROUTES } from '../constants/app';
import { useGuideStore } from '../stores/guideStore';

export const useNavigation = () => {
  const history = useHistory();
  const setActivePageId = useGuideStore(s => s.setActivePageId);

  const navigate = (path: string, openNewTab: boolean) => {
    if (path.includes(`${window.location.origin}/guidelines`) && !openNewTab) {
      const { guideId, pageId, hash } = extractIdsFromString(
        path.replace(`${window.location.origin}/guidelines`, ''),
      );

      if (pageId) {
        setActivePageId(null);
        history.push({
          pathname: ROUTES.GUIDE_PAGE(guideId, pageId),
          hash,
        });
      } else {
        setActivePageId(null);
        history.push({
          pathname: ROUTES.GUIDE(guideId),
        });
      }
    } else {
      window.open(path, openNewTab ? '_blank' : '_self');
    }
  };

  return { navigate };
};

const extractIdsFromString = (inputString: string) => {
  const regex = /\/guide\/([a-f\d-]+)(?:\/page\/([a-f\d-]+))?(?:#(.+))?/;
  const matches = inputString.match(regex);

  if (matches) {
    const guideId = matches[1];
    const pageId = matches[2] || null;
    const hash = matches[3] || null;
    return {
      guideId,
      pageId,
      hash,
    };
  } else {
    return null;
  }
};
